import React, { useEffect, useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Cell, Pie, PieChart } from "recharts";

import "../../../../assets/stlyes/SubjectOverView/OverallProgressTable.scss";

const PieCharts = (props) => {
  const { pieResult } = props;
  const [pieData, setPieData] = useState();

  const getResult = () => {
    setPieData(pieResult.filter((itema) => itema.name !== "0").map((itema) => ({ name: itema.name.charAt(itema.name.length - 1), value: parseInt(itema.value), })));
  }

  const renderCustomTooltip = (pieData) => {
    if (pieData && pieData.length > 0) {
      const total = pieData.reduce((accumulator, entry) => accumulator + entry.value, 0);
      const tooltipContent = [
        <p key="total">{`Total: ${total}`}</p>,
        ...pieData.map((entry, index) => (
          <p key={index} className="d-flex align-items-center">
            <div className="greenPointer__" style={{ background: entry.name === "G" ? "var(--greater-colour)" : (entry.name === "E") ? "var(--expected-colour)" : (entry.name === "W") ? "var(--working-towards)" : (entry.name === "B") ? "var(--below-colour)" : (entry.name === "A") ? "var(--absent-colour)" : "white" }}></div>&nbsp;{entry.name === "G" ? `${entry.name}DS: ${entry.value}` : entry.name === "E" ? `${entry.name}XS: ${entry.value}` : entry.name === "W" ? `${entry.name}TS: ${entry.value}` : entry.name === "B" ? `${entry.name}LW: ${entry.value}` : entry.name === "A" ? `Absent: ${entry.value}` : null}
          </p>
        )),
      ];
      return tooltipContent;
    } else {
      return null;
    }
  };

  useEffect(() => {
    getResult();
  }, [pieResult])

  return (
    <OverlayTrigger trigger="hover" placement="right" overlay={<Popover id="popover-basic" className="custom-tooltip" style={{ backgroundColor: "#fff", padding: "10px", border: "1px solid #ccc" }}>{renderCustomTooltip(pieData)}</Popover>}>
      <div className="d-flex align-items-center justify-content-center">
        <PieChart width={30} height={30} className="piee">
          {pieData && <Pie data={pieData} cx="50%" cy="50%" dataKey="value" outerRadius={15} strokeWidth={1} isAnimationActive={true}>
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.name === "G" ? "var(--greater-colour)" : (entry.name === "E") ? "var(--expected-colour)" : (entry.name === "W") ? "var(--working-towards)" : (entry.name === "B") ? "var(--below-colour)" : (entry.name === "A") ? "var(--absent-colour)" : "white"} />
            ))}
          </Pie>}
        </PieChart>
      </div>
    </OverlayTrigger>
  )
}

export { PieCharts }
